import moment from "moment";
import ExternalMAMMetadataItem from "./external-mam-metadata-item";

export interface ExternalMAMAdditionalDataGeneral {
  name: string;
  autoPull: boolean;
  connectingTested: boolean;
}

export interface ExternalMAMDropBucket {
  bucketName?: string;
  region?: string;
  prefix?: string;
  accessKey?: string;
  secretKey?: string;
}

export interface ExternalMAMAdditionalData {
  loginData: Record<string, string>;
  general: ExternalMAMAdditionalDataGeneral;
  languages: string[];
  subtitles: string[];
  metadata: Record<string, unknown>;
  referenceFields?: string[];
  dropBucket?: ExternalMAMDropBucket;
}

export class ExternalMAMGatewayProvider {
  constructor(
    public id: string,
    public externalMAMType: number,
    public tenantId: number,
    public createdDate: moment.Moment,
    public additionalData: ExternalMAMAdditionalData,
    public isActive: boolean,
  ) {}

  public static FreshExternalMAMGatewayProvider(
    pid: number,
  ): ExternalMAMGatewayProvider {
    const ad: ExternalMAMAdditionalData = {
      subtitles: [],
      languages: [],
      loginData: {},
      metadata: {},
      general: {
        name: "",
        autoPull: false,
        connectingTested: false,
      },
    };
    switch (pid) {
      case 1: // brightcove
        ad.loginData = {
          accountId: "",
          username: "",
          password: "",
        };
        break;
      case 2: // dalet
        ad["loginData"] = {
          username: "",
          password: "",
          daletBaseUrl: "",
          authType: "perCall",
        };
        ad["dropBucket"] = {
          bucketName: "",
          region: "",
          prefix: "",
          accessKey: "",
          secretKey: "",
        };
        break;
      default:
        break;
    }
    return new ExternalMAMGatewayProvider("", pid, 0, null, ad, true);
  }
  public setMetadata(metadata: [{ id: number; name: string }]): void {
    metadata.forEach((element) => {
      this.updateMetadata(element.name, null);
    });
  }
  public mergeMetadata(metadata: [{ id: number; name: string }]): void {
    metadata.forEach((element) => {
      if (!this.getMetadata(element.name)) {
        this.updateMetadata(element.name, null);
      }
    });
    for (const [key] of Object.entries(this.additionalData.metadata)) {
      if (metadata.findIndex((x) => x.name === key) === -1) {
        delete this.additionalData.metadata[key];
      }
    }
  }
  public updateGeneral(key: string, value: string): void {
    (this.additionalData.general as unknown as Record<string, string>)[key] =
      value;
  }
  public updateMetadata(key: string, value: string): void {
    this.additionalData.metadata[key] = value;
  }
  public updateReferenceFields(referenceFields: Array<string>): void {
    this.additionalData.referenceFields = referenceFields;
  }
  public updateLoginData(key: string, value: string): void {
    this.additionalData.loginData[key] = value;
  }
  public updateDropBucket(key: string, value: string): void {
    if (!this.additionalData["dropBucket"]) {
      this.additionalData["dropBucket"] = {};
    }
    this.additionalData["dropBucket"][key] = value;
  }
  public updateSubtitles(subtitles: string[]): void {
    this.additionalData.subtitles = subtitles;
  }
  public updateLanguages(languages: string[]): void {
    this.additionalData.languages = languages;
  }
  public AbleToLogin(): boolean {
    return this.additionalData.general.connectingTested;
  }
  public loginSuccessful(): void {
    this.additionalData.general.connectingTested = true;
  }
  public resetLogin(): void {
    this.additionalData.general.connectingTested = false;
  }
  public connectingTested(): boolean {
    return this.additionalData.general.connectingTested;
  }
  public getName(): string {
    return this.additionalData.general.name;
  }
  public getMetadata(key: string): unknown {
    return this.additionalData.metadata[key];
  }
  public getMetadataValues(): Array<ExternalMAMMetadataItem> {
    return Object.entries(this.additionalData.metadata).map(
      (x) => x[1] as ExternalMAMMetadataItem,
    );
  }
}
